// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_-aI","cls2":"LoswpPackPitch-cls2_ID4 LoswpPackPitch-cls1_-aI"};